/**
 * 入力候補の一覧。
 *
 * スプリでは支出入力の手間を減らすことを重視しており、
 * 「よくある支出」のプリセットから支出名の候補を出す。
 * 過去に入力した支出 (履歴) は候補に出さない。
 */
import type { ExpenseSuggestion } from "@spli/core";

export interface SuggestionListProps {
  suggestions: ExpenseSuggestion[];
  activeIndex: number;
  onSelect(suggestion: ExpenseSuggestion): void;
}

export function SuggestionList({ suggestions, activeIndex, onSelect }: SuggestionListProps) {
  if (suggestions.length === 0) return null;

  return (
    <ul className="suggestions" role="listbox" aria-label="支出の入力候補">
      {suggestions.map((suggestion, index) => (
        <li key={suggestion.title} role="presentation">
          <button
            type="button"
            role="option"
            aria-selected={index === activeIndex}
            className={`suggestions__item${index === activeIndex ? " suggestions__item--active" : ""}`}
            // onMouseDown を使う: input の blur より先に選択を確定させるため
            onMouseDown={(event) => {
              event.preventDefault();
              onSelect(suggestion);
            }}
          >
            <span className="suggestions__body">
              {/* 一覧そのものが候補なので、「候補」とは書かない (自明なため) */}
              <span className="suggestions__title">{suggestion.title}</span>
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
